<template>
  <b-row>
    <b-col class="container text-right">
      <!-- <b-button
        variant="primary"
        @click="onBtnAddClicked"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>เพิ่มข้อมูล</span>
      </b-button> -->
    </b-col>

    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter
              :mode="tab.mode"
              @handleSubmit="searchFilterSubmit"
              ref="searchFilterComponent"
            />
          </b-col>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-col v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
      <commonTable
        ref="tableCommon"
        :mode="tab"
        @handle-select="onSelectChange"
      />
    </b-col>

    <b-col cols="12">
      <b-card>
        <div class="d-flex justify-content-end">
          <!-- <b-button variant="secondary" @click="onBackBtnClicked">
              ยกเลิก
            </b-button> -->
          <b-button variant="primary" @click="onRemoveUserClicked">
            ลบผู้ใช้งานออกจากกลุ่มสิทธิ์
          </b-button>
        </div>
      </b-card>
    </b-col>

    <ModalAddUser
      ref="modalAddUser"
      :users="userAddList"
      @handle-submit="onAddUserSubmit"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import commonTable from "./components/roleUserTable.vue";
import SearchFilter from "./components/RoleUserSearchFilter.vue";
import ModalAddUser from "./components/ModalAddUser.vue";

import * as roleStore from "@/store/api/role/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    ModalAddUser,
  },
  data() {
    return {
      tabs: [{ title: "จัดการผู้ใช้งาน", mode: "List" }],
      activeTab: ["List"],
      userAddList: [],
      userList: [],
      selects: [],
      provinces: [],
      provincialUserIdUpper: "25E8AF7C-D072-47FD-985B-FB1EEFC44764",
      provincialUserIdLower: "25e8af7c-d072-47fd-985b-fb1eefc44764",
    };
  },
  mounted() {
    this.getCurrentRoleUser();
    this.setBreadcrumb();
  },
  methods: {
    setBreadcrumb() {
      const _this = this;

      roleStore
        .getById(_this.$route.query.id)
        .then((response) => {
          const roleData = response.data.data;

          console.log("route name", this.$route.meta);
          _this.$route.meta.breadcrumb[2].text = roleData.roleName;

          // Add a temporary query parameter.
          _this.$router.replace({
            query: { temp: Date.now(), id: _this.$route.query.id },
          });
          // Remove the temporary query parameter.
          _this.$router.replace({
            query: { temp: undefined, id: _this.$route.query.id },
          });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    onSelectChange(selects) {
      this.selects = selects;
    },
    onRemoveUserClicked() {
      const userIds = this.selects.map((value) => value.userId);

      const _this = this;

      console.log("userIds", userIds);

      if (userIds.length === 0) {
        this.$bvToast.toast("กรุณาเลือกผู้ใช้งานที่จะลบออกจากกลุ่มสิทธิ์", {
          title: `กรุณาเลือกผู้ใช้งานที่จะลบออกจากกลุ่มสิทธิ์อย่างน้อย 1 รายการ`,
          variant: "danger",
          solid: false,
        });

        return;
      }

      this.$swal({
        title: "คุณต้องการลบผู้ใช้งานออกจากกลุ่มสิทธิ์ใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = {
            roleId: this.$route.query.id,
            userIds,
            userId: userData.userId(),
          };

          roleStore
            .removeRoleUserList(params)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้ลบผู้ใช้งานออกจากกลุ่มสิทธิ์แล้ว`,
                  variant: "success",
                  solid: false,
                });

                //_this.$refs.searchFilter.onSearchBtnClicked();

                _this.getCurrentRoleUser();
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาด`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาด`,
                variant: "danger",
                solid: false,
              });
              console.log("error", error);
            });
        }
      });
    },
    getCurrentRoleUser() {
      //console.log(this.$refs.tableCommon, this.$refs)
      this.$refs.tableCommon[0].onSearchSubmit()
    },
    searchFilterSubmit(params) {
      //this.$refs.tableCommon.onSearchSubmit(params)
      //this.$route.query.id
      const _this = this;

      params.roleId = this.$route.query.id;

      roleStore
        .getRoleUserAddList(params)
        .then((response) => {
          _this.userAddList = response.data.data;

          _this.$refs.modalAddUser.$refs["modal-add-user"].show();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onAddUserSubmit(selects) {
      const _this = this;

      const userIds = selects.map((value) => value.userId);

      const params = {
        userIds,
        roleId: this.$route.query.id,
        userId: userData.userId(),
      };

      roleStore
        .addRoleUserList(params)
        .then((response) => {
          if (response.data.success === true) {
            _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกเพิ่มผู้ใช้งานเข้ากลุ่มสิทธิ์แล้ว`,
              variant: "success",
              solid: false,
            });

            console.log("_this.refs", _this.$refs);

            _this.$refs.searchFilterComponent[0].onSearchBtnClicked();

            _this.getCurrentRoleUser();
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch((error) => {
          _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            title: `เกิดข้อผิดพลาด`,
            variant: "danger",
            solid: false,
          });
          console.log("error", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
